export { default as WizardContainer } from './WizardContainer';
export { default as GeneralStep } from './GeneralStep';
export { default as DimensionsStep } from './DimensionsStep';
export { default as VirtualSKUStep } from './VirtualSKUStep';



// WEBPACK FOOTER //
// ./src/modules/product/wizard/pages/index.js